import { render, staticRenderFns } from "./ProductRatingControls.vue?vue&type=template&id=6e2a5907&scoped=true"
import script from "./ProductRatingControls.vue?vue&type=script&lang=js"
export * from "./ProductRatingControls.vue?vue&type=script&lang=js"
import style0 from "./ProductRatingControls.vue?vue&type=style&index=0&id=6e2a5907&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a5907",
  null
  
)

export default component.exports